import React from 'react'
import { Container } from 'react-bootstrap'
import { BigCard, Tabela, Header } from '@equipedigitalfloripa/ed-cms/components'
import * as categoriaArquivosApi from '../api/categoriaArquivos'
import { useSelector } from 'react-redux'

const CategoriaArquivos = () => {
  const translations = useSelector(state => state.translations.translations)
  const categoriaArquivosTranslations = translations['system-categoriaArquivos']

  const columns = [
    {
      title: "nome",
      field: "title",
    },
  ];

  return (
    <React.Fragment>
      <Header title={"Categoria Arquivos"} subtitle={"Lista das categorias dos arquivos"}>
        <i className="fas fa-coins awesome-header"></i>
      </Header>
      <Container className="page-content">
        <BigCard>
          <Tabela
            columns={columns}
            fetchFunction={categoriaArquivosApi.fetchItems}
            removeFunction={categoriaArquivosApi.removeItem}
            statusFunction={categoriaArquivosApi.statusItem}
            title={"Categoria Arquivos"}
            url={'categoria_arquivos'}
          />
        </BigCard>

      </Container>
    </React.Fragment>
  )
}

export default CategoriaArquivos
